





import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  computed: mapState(["currentCondition"]),

  watch: {
    currentCondition() {
      document.body.className = this.currentCondition;
    }
  }
});
